import React, { Fragment, useState, useContext, useEffect } from 'react';
import formatDate from '../../utils/formatDate';

import { JobAppContext } from '../../GlobalState'

import { getEmailTemplates, email_external, resendEmail, optOutEmail } from '../../api'

import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, Row, Col, Table, Tooltip
} from 'reactstrap';
import { Form, Input, Textarea } from '../../components'

const EmailRecord = ({ email, openEmail, updateRec, config, showOptOut, optOut }) => {
	
	const [ isSending, setIsSending ] = useState(false);
	const [ isDisabled, setDisabled ] = useState(false);

	const [ show, setShow ] = useState(false);
	const [ emailInfo, setEmailInfo ] = useState(null);

	useEffect(() => {
		if ( config ) {
			showReminderDetails();
		}
	}, [])

	const resendEmailBtn = (id) => {
		if ( email.uuid !== '' ) {
			
			// console.log('counting down from 5')
			setIsSending(true);
			setTimeout(() => {
				// console.log(' ---> executing...')
				resendEmail({
					email_id: email.id,
					uuid: email.uuid,
					job_id: email.job_id
				}).then(oResp => {
					// console.log(' ---> done.')
					setIsSending(false);
					if ( oResp.status == "success" ) {
						updateRec(oResp.email);
					} else {
						alert('Error sending email: ' + oResp.error)
					}
				})
			}, 3000)

		} else {
			console.log('id', id, 'email', email)
			alert('no valid uuid value found')
		}
	}

	const reminderOptOut = (id) => {	
		
		// add 1/2 second delay to prevent doubleclick.
		setDisabled(true);
		setTimeout(() => {
			// function only needs id of email record since opt_out value is just being flipped 0 -> 1 -> 0
			optOutEmail({ id }).then(oResp => {
				if ( oResp.status == "success" ) {
					optOut(id);
				} else {
					alert('Error updating Optout option for email reminders. Contact Support')
				}
				setDisabled(false);
			})
		}, 500)

	}

	const showReminderDetails = () => {

		Date.prototype.addDays = function(days) {
			var date = new Date(this.valueOf());
			date.setDate(date.getDate() + days);
			return date;
		}

		Date.prototype.subDays = function(days) {
			var date = new Date(this.valueOf());
			date.setDate(date.getDate() - days);
			return date;
		}

		var currentDate = new Date();
		var formattedDate = new Date(email.created_at);
		var firstReminderDate = formattedDate.addDays(config.first_reminder);
		var expireDate = formattedDate.addDays(config.request_expires);
		var warningDate = expireDate.subDays(config.warn_sender);

		let firstReminderSoon = currentDate < firstReminderDate ? true : false;
		let warningSoon = currentDate > warningDate & currentDate < expireDate ? true : false;
		
		setEmailInfo({
			currentDate: currentDate.toISOString().slice(0, 10),
			formattedDate: formattedDate.toISOString().slice(0, 10),
			firstReminderDate: firstReminderDate.toISOString().slice(0, 10),
			warningDate: warningDate.toISOString().slice(0, 10),
			expireDate: expireDate.toISOString().slice(0, 10)
		})

		// return {
		// 	currentDate: currentDate.toISOString().slice(0, 10),
		// 	formattedDate: formattedDate.toISOString().slice(0, 10),
		// 	firstReminderDate: firstReminderDate.toISOString().slice(0, 10),
		// 	warningDate: warningDate.toISOString().slice(0, 10),
		// 	expireDate: expireDate.toISOString().slice(0, 10)
		// }

	}

	let resend_uuids = email?.resend_uuids?.length > 0 ? JSON.parse(email?.resend_uuids) : [];
	let expired = emailInfo?.currentDate > emailInfo?.expireDate;

	return (
		<>
			{showOptOut && expired && (
				<Tooltip
					isOpen={show}
					toggle={() => setShow(!show)}
					target={'email_' +email.id}
				>
					<div>
						{/* First Reminder Send Date: {formatDate(emailInfo?.firstReminderDate, 'L')}<br />
						Warning Notice Send Date: {formatDate(emailInfo?.warningDate, 'L')}<br /> */}
						Expired on {formatDate(emailInfo?.expireDate, 'L')}
					</div>
				</Tooltip>
			)}
			<tr>
				<td>
					<div>
						{formatDate(email.created_at, 'L')}<br />
						{formatDate(email.created_at, 'LT')}
					</div>
				</td>
				<td>
					<div className="pl-3">
						<span className="font-weight-bold">Recipient:</span> {email.to}<br />
						<span className="font-weight-bold">Subject:</span> {email.subject}
					</div>
				</td>
				<td>
					{email.status}
					{resend_uuids?.length > 0 && (
						<> ( {resend_uuids?.length + 1} )</>
					)}
				</td>
				{showOptOut && (
					<>
						<td>
							<input 
								title="Check to send reminders"
								type="checkbox" name="opt_out" className="ml-3"
								checked={!email.opt_out}
								onChange={() => reminderOptOut(email.id)} disabled={isSending || isDisabled || expired} />
							{email.last_reminder_date && (
								<span className="ml-2" style={{ fontSize: '.8rem' }}>Last Sent: {formatDate(email.last_reminder_date, 'L')}</span>
							)}
							{expired && (
								<span id={'email_' +email.id} className="ml-2" style={{ fontSize: '.8rem', color: 'red' }}>Expired</span>
							)}
						</td>
						{/* <td>
							<div>
								First Reminder Send Date: {formatDate(emailInfo?.firstReminderDate, 'L')}<br />
								Warning Notice Send Date: {formatDate(emailInfo?.warningDate, 'L')}<br />
								Reminder Expiration Date: {formatDate(emailInfo?.expireDate, 'L')}
							</div>
						</td> */}
					</>
				)}
				<td>
					<Button size="sm" onClick={() => openEmail(email.id)} disabled={isSending || isDisabled}>View</Button>
					{email.uuid && (
						<Button color="secondary" size="sm" className="ml-3" onClick={() => resendEmailBtn(email.id)} disabled={isSending || isDisabled}>
							{isSending ? 'Resending...' : 'Resend'}
						</Button>
					)}
				</td>
			</tr>
		</>
	)
}

const EmailLinkHistory = ( prop ) => {

	const { user } = useContext(JobAppContext);

	const company = user.memberships[0].company;
	const config_settings = company.config_settings ? JSON.parse(company.config_settings) : false;

	// these fields should be filtered for display to the end user.
	// Other fields will be evaluated and replaced on the server side (EmailController@email_external)
	const filter_values = (val) => {
	
		const merge_fields = {
			'company_name': company.name, 
			'job_name': prop.jobName, 
			'user_name': user.name, 
			'user_email': user.email,

			'customer_name': prop.customerName,
			'job_number': prop.jobNumber         // Customer Reference #
		}
		var filtered_value = val;
		for ( const fld in merge_fields ) {
			filtered_value = filtered_value.replace('[' +fld+ ']', merge_fields[fld]);
		}
		
		return filtered_value;
	}

	var val = config_settings?.subject ?? '[company_name] | [job_name]';
	var proc_subject = val;
	// var proc_subject = filter_values(val);

	var val = config_settings?.body ?? 'Hi,\n\nPlease fill out the form located at the link below:\n\n[job_name]\n[link address]\n\nThanks,\n[user_name]\n[user_email]';
	var proc_body = val;
	// var proc_body = filter_values(val);

  /* setup state for this compoenent **************************************** */
  	const defaultEmailForm = {
		to: '',
		from: config_settings?.from ?? 'Job App Admin <admin@jobinfo.app>',
		subject: proc_subject,
		body: proc_body,
		uuid: null,
		opt_out: 0
	}
	const [ isSending, setSending ]        = useState(false);
	const [ formStatus, setFormStatus ]    = useState('new');

	const [ readonly, setReadOnly ]        = useState(false);
	const [ id, setJobID ]                 = useState(prop.id);
	const [ email_instr, setInstructions ] = useState(false);
	const [ emailModal, toggleEmailModal ] = useState(false);
	const [ email, setEmail ]              = useState(defaultEmailForm);

	const [copiedField, setCopiedField] = useState(null);

	const [ emailTemplates, setEmailTemplates ] = useState([]);

	/* open/close modal and instruction section ******************************* */
	const openCloseModal = () => {
		if (!emailModal && emailTemplates.length == 0) {
			fetchEmailTemplates();
		}
		toggleEmailModal(!emailModal);
	}
	const openCloseInstr = () => setInstructions(!email_instr);

	const fetchEmailTemplates = () => {
		getEmailTemplates('share').then(oResp => {
			setEmailTemplates(oResp);
		})
	}

	/* handle field changes *************************************************** */
	const handleChange = (event) => {
		const { type, name, value, checked } = event.target;

		setFormStatus('edit');
		if ( type == "checkbox" ) {
			setEmail({ ...email, [name]: checked ? 0 : 1 });
		} else {
			setEmail({ ...email, [name]: value });
		}
		
	}

	/* change state of email form ********************************************* */
	const cancelEmail = () => {
		setEmail(defaultEmailForm);
		setFormStatus('new');
		toggleEmailModal(false);
	}

	const handleSubmit = () => {
		// validate user-entered emails with regex
		var emails = email.to.split(',');
		var error_found = false;
		if ( emails.length > 0 ) {
			for (let i=0; i<emails.length; i++) {
				// console.log('checking email [' +i+ ']:', emails[i])
				if ( !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test( emails[i].trim() )) {
				error_found = true;
				break;
				}
			}
			if ( error_found ) {
				alert('Error in email(s) entered. Please check input and try again.');
				return false;
			} else {
				setSending(true);
				let data = { id, ...email };
				email_external(data).then(oResp => {
					setSending(false);
					if ( oResp.status == "complete" ) {
						oResp.results.forEach(result => {
							prop.addNew(result.email);
						})
						setFormStatus('sent');
					} else {
						alert('Error sending email: ' + oResp.error)
					}
				})
			}
		}
	}

	/* open/view previously-sent emails *************************************** */
	const compose_new = () => {
		setReadOnly(false);
		openCloseModal();
	}
  
	const viewEmail = (id) => {

		var chosen_email = prop.email_list.find(email => email.id == id);
		setFormStatus(chosen_email.status);
		setEmail({
			id,
			to: chosen_email.to,
			subject: chosen_email.subject,
			body: chosen_email.body,
			uuid: chosen_email.uuid ?? null
		})
		setReadOnly(true);
		openCloseModal();
	}

	const optOutEmail = (id) => {
		var selected_email = prop.email_list.find(email => email.id == id);
		// Toggle the opt_out value before updating state (server already toggled it)
		prop.updateRec({ ...selected_email, opt_out: selected_email.opt_out ? 0 : 1 });
	}

	const applyTemplate = (event) => {
		const { name, value } = event.target;
		if ( value == 0 ) {
			setEmail({
				...email,
				subject: proc_subject,
				body: proc_body
			})
			return;
		} else {
			const template = emailTemplates.find(template => template.id == value);
			setEmail({
				...email,
				subject: template.subject,
				body: template.body
			})
		}
	}

	const copyToClipboard = (text) => {
		navigator.clipboard.writeText(text);
		setCopiedField(text);
		setTimeout(() => {
			setCopiedField(null);
		}, 2000);
	}

	const mergeFields = [ 
		{ value: '[link_address]', title: 'dynamically-created link to this job' },
		{ value: '[job_number]', title: 'Job Number' },  // Customer Reference Number
		{ value: '[customer_name]', title: 'Customer Name' },
		{ value: '[job_name]', title: 'Job Name' },
		{ value: '[company_name]', title: 'Company Name' },
		{ value: '[user_name]', title: 'User Name' },
		{ value: '[user_email]', title: 'User Email' }
	];

	function nl2br (str, is_xhtml) {   
		var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';    
		return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
	}

	return (
		<div>
			<Modal size="lg" isOpen={emailModal} toggle={openCloseModal}>
				<Form onSubmit={handleSubmit}>
					<ModalHeader toggle={openCloseModal}>
						{!readonly ? (<>Compose Email{' '}<i className="fa fa-info-circle mx-3" style={{ cursor: 'pointer' }} title="Click for Instructions" onClick={openCloseInstr}></i></>) : "View Email"}
					</ModalHeader>
					<ModalBody>
						{email_instr && (
							<div className="my-3">
								<label>Instructions:</label>
								<p>To send a customized email including a link to this job, follow the instructions below:</p>
								<ol className="share_instructions" style={{ paddingLeft: '5px' }}>
									<li>
										Enter your intended Recipient email(s) into the field labeled "To:"<br />
										<cite style={{ fontSize: '.9rem' }}>Separate emails with a comma<br />(ex. email@company.com, email2@company.com)</cite>
									</li>
									<li>
										Update the Subject and/or Body.<br />
										<cite style={{ fontSize: '.9rem' }}>Note: The [link address] text denotes where the custom job link will be located in the email message body</cite>
									</li>
									<li>Click the "Send Email" button</li>
								</ol>
							</div>
						)}
						<div className="shareForm">
							<div className="form-row">
								<div className="col-md">
									<label htmlFor="to">
										To: <span className="required">*</span>{' '}
										{!readonly && (
											<span className="d-inline small">
												Separate email addresses with a comma
											</span>
										)}
									</label>
									{!readonly ? (
										<>
											<input
												autoFocus={true}
												name="to"
												onChange={handleChange}
												type="email"
												value={email.to}
												className="form-control"
												placeholder="Recipients"
												required
												multiple
											/>
											<div className="invalid-feedback" />
										</>
									) : (
										<span>{email.to}</span>
									)}
								</div>
							</div>
							<div className="form-row mt-3">
								<div className="col-md">
									<label>From:</label>
									<span>
										{user.memberships[0].company?.id == 93 ? (
											<code>Blue Diamond Materials &lt;BlueDiamond@jobinfo.app&gt;</code>
										) : (
											<code>Job App Admin &lt;admin@jobinfo.app&gt;</code>
										)}
									</span>
								</div>
							</div>
							{(!readonly && emailTemplates.length > 0) && (
								<div className="form-row mt-3">
									<div className="col-md">
										<label>Templates:</label>
										<select name="email_template_id" className="form-control" onChange={applyTemplate}>
											<option value="0">Select Template</option>
											{emailTemplates.map(template => (
												<option key={template.id} value={template.id}>{template.title}</option>
											))}
										</select>
									</div>
								</div>
							)}
							<div className="form-row mt-3">
								<div className="col-md">
									<Input
										autoFocus={true}
										name="subject"
										onChange={handleChange}
										label="Subject:"
										type="text"
										value={email.subject}
										isRequired={1}
										readOnly={readonly}
										maxLength={200}
									/>
								</div>
							</div>
							<div className="form-row mt-3">
								<div className="col-md d-flex">
									<div className={!readonly ? "w-75" : "w-100"}>
										{!readonly ? (
											<Textarea
												onChange={handleChange}
												name="body"
												value={email.body}
												label="Body:"
												rows={9}
												readOnly={readonly}
											/>
										) : (
											<p className="py-2 px-3 border border-secondary rounded"
												dangerouslySetInnerHTML={{ __html: nl2br(email.body) }} />
										)}
									</div>
									{!readonly && (
										<div className="w-25 p-3">
											<cite style={{ fontSize: '.9rem' }}>
												<h6 title="The following merge fields can be included in the Subject and/or Body">Merge Fields</h6>
												<ul className="list-unstyled">
													{mergeFields.map((mf, idx) => (
														<li key={idx} className="cursor-pointer merge-field-item" onClick={() => copyToClipboard(mf.value)}>
															<span title={mf.title}>{mf.value}</span>{' '}
															{copiedField === mf.value ? (
																<><i className="fas fa-check ml-1"></i> <span className="small">copied</span></>
															) : (
																<i className="far fa-copy ml-1 hover-icon"></i>
															)}
														</li>
													))}
												</ul>
											</cite>
										</div>
									)}
								</div>
							</div>
							{config_settings.send_reminders && (formStatus == 'new' || formStatus == 'edit') && (
								<div className="form-row mt-3">
									<div className="col-md">
										<input
											type="checkbox"
											name="opt_out"
											value={1}
											checked={!email.opt_out}
											onChange={handleChange}
										/>
										<label htmlFor="opt_out" className="d-inline pl-3">Send Reminder Emails</label>
									</div>
								</div>
							)}
						</div>

					</ModalBody>
					<ModalFooter>
						{!readonly ? (
							<>
								<Button color="danger" size="sm" onClick={cancelEmail} style={{ position: 'absolute', left: 0, marginLeft: '20px' }}>
									Cancel
								</Button>

								{formStatus == 'sent' && (
									<i className="far fa-check-circle"></i>
								)}
								{(email.to.trim() == '' || email.subject.trim() == '' || email.body.trim() == '' || isSending || formStatus == 'sent') ? (
									<Button type="submit" color="secondary" size="sm" disabled={true} outline>
										{isSending ? 'Sending...' : 'Send Email'}
									</Button>
								) : (
									<Button type="submit" color="success" size="sm" disabled={false}>
										Send Email
									</Button>
								)}
							</>
						) :(
							<Button color="danger" size="sm" onClick={cancelEmail}>
								Close
							</Button>
						)}
					</ModalFooter>
				</Form>
			</Modal>

			<h3 style={{ padding: '10px 20px', margin: '10px 0', backgroundColor: '#EAEAEA' }}>
				Email Job Link
				<Button color="primary" size="sm" onClick={compose_new} className="ml-3">Compose</Button>
			</h3>

			<Row>
				<Col>
					{prop.email_list.length > 0 ? (
						<div className="historyList">
							<h5>Email History</h5>
							<Table responsive size="sm">
								<thead>
									<tr>
										<th>Sent</th>
										<th>Details</th>
										<th>Status</th>
											{config_settings.send_reminders && (
												<>
													<th>
														Reminders
														{/* <i className="fa fa-info-circle ml-1" style={{ cursor: 'pointer' }} 
															title="Uncheck to opt-out of sending reminders" 
															onClick={() => console.log('show config settings')}></i> */}
													</th>
													{/* <th>
														Info
													</th> */}
												</>
											)}
										<th>&nbsp;</th>
									</tr>
								</thead>
								<tbody>
									{prop.email_list.map(email_log => 
										<EmailRecord 
											key={email_log.id} 
											email={email_log} 
											updateRec={prop.updateRec} 
											openEmail={(id) => viewEmail(id)}
											config={config_settings}
											showOptOut={config_settings.send_reminders}
											optOut={(id) => optOutEmail(id)} />
									)}
								</tbody>
							</Table>
						</div>
					) : (
						<div style={{ border: 'dotted 1px #CACACA', padding: '20px', margin: '20px' }}>
							Click the "Compose" button above, to prepare and send an email containing a job link.
						</div>
					)}
				</Col>
			</Row>
		
		</div>
	)
}

export default EmailLinkHistory;
